import { $, html } from "@utils/dom";
import { once } from "@utils/listener";
import { moduleDelays } from "./utils";

const SELECTOR = "[data-site-loader]";

class SiteLoader {
  constructor() {
    this.el = $(SELECTOR);
    this.letter = $('.site-loader__letter:nth-child(1)');
  }

  loaded() { moduleDelays(350, 200); }

  scripts() {
    const completed = getComputedStyle(this.letter).getPropertyValue('transform') == 'none';
    if( completed ) return;

    return new Promise(resolve => {
      once(this.letter, 'animationend', resolve);
    });
  }

  ready() {
    return this.el.animate({ opacity: 0 }, {
      duration: 250,
      fill: 'forwards',
      easing: 'linear'
    })
    .finished
    .then(() => {
      // remove from DOM when completed
      if( this.el ) this.el.remove();

      // add class on body when transition is ready
      html.classList.add("--js-ready");

      this.el = null;
      this.letter = null;
    });
  }
}

export default SiteLoader;
